import applicationApi from '@/api/application.api'
import colorsService from '@/service/colors.service'

const module = {
  namespaced: true,
  state: {
    avisCampagne: null,
    categoriesContrats: [],
    /**
     * [
     *    {
     *      "id": 1,
     *       "code": "A",
     *      "nom": "Avoine",
     *      "codesGrainesGeofolia": [],
     *      "typeCultureFils": [
     *          {
     *               "id": 1,
     *                "code": "A",
     *                "nom": "Avoine",
     *                "codesGrainesGeofolia": [],
     *                "typeCultureFils": []
     *          }
     *       ]
     *    }
     * ]
     */
    arborescenceTypeCulture: [],
    /**
    * {"code":"BT",
    * "libelle":"blé tendre",
    * "caracteristiquesPrincipales":["POIDS_SPECIFIQUE_EN_KG_PAR_HECTOLITRE","TAUX_HUMIDITE","TAUX_IMPURETE","TAUX_PROTEINE"],
    * "caracteristiquesSecondaires":["FLAIR_ANORMAL","PRESENCE_INSECTE","TAUX_GERME"]}
    */
    grainesRs3: [],
    /**
     * libelleGraineRs3ParCode.code => libelle.
     */
    libelleGraineRs3ParCode: {},
    anneeRecolteEnCours: null,
    anneeRecolteEngagementPrixCampagne: null,
    isBagOuverte: false,
    anneeRecolteActive: null,
    codeGraineActive: null
  },

  getters: {
    categoriesContrats (state) {
      return state.categoriesContrats
    },
    arborescenceTypeCulture (state) {
      return state.arborescenceTypeCulture
    },
    grainesRs3 (state) {
      return state.grainesRs3
    },
    libelleGraineRs3ParCode (state) {
      return state.libelleGraineRs3ParCode
    },
    anneeRecolteEnCours (state) {
      return state.anneeRecolteEnCours
    },
    anneeRecolteSuivante (state) {
      return (Number(state.anneeRecolteEnCours) + 1).toString()
    },
    avisCampagne (state) {
      return state.avisCampagne
    },
    anneeRecolteActive (state) {
      return state.anneeRecolteActive
    },
    codeGraineActive (state) {
      return state.codeGraineActive
    },
  },

  mutations: {
    UPDATE_CATEGORIES_CONTRATS (state, categoriesContrats) {
      // Ajoute la couleur associé à chaque contrat
      categoriesContrats = categoriesContrats.map((element, index) => {
        element.color = colorsService.pieChart.categoriesContrats[index]
        return element
      })
      state.categoriesContrats = categoriesContrats
    },
    UPDATE_ARBORESCENCE_TYPE_CULTURE (state, arborescenceTypeCulture) {
      state.arborescenceTypeCulture = arborescenceTypeCulture
    },
    UPDATE_GRAINES_RS3 (state, grainesRs3) {
      state.grainesRs3 = grainesRs3
    },
    UPDATE_LIBELLE_GRAINE_RS3_PAR_CODE (state, libelleGraineRs3ParCode) {
      state.libelleGraineRs3ParCode = libelleGraineRs3ParCode
    },
    UPDATE_ANNEE_RECOLTE_EN_COURS (state, anneeRecolteEnCours) {
      state.anneeRecolteEnCours = anneeRecolteEnCours
    },
    UPDATE_AVIS_CAMPAGNE (state, avisCampagne) {
      state.avisCampagne = avisCampagne
    },
    UPDATE_ANNEE_RECOLTE_ACTIVE (state, anneeRecolte) {
      state.anneeRecolteActive = anneeRecolte
    },
    UPDATE_CODE_GRAINE_ACTIVE (state, codeGraine) {
      state.codeGraineActive = codeGraine
    },
  },

  actions: {
    fetchAnneeRecolteEnCours ({ commit }) {
      return applicationApi.getAnneeRecolteEnCours().then(result => {
        commit('UPDATE_ANNEE_RECOLTE_EN_COURS', result)
        return result
      })
    },
    fetchCategoriesContrats ({ commit }) {
      return applicationApi.getAllCategoriesContrats()
        .then(contrats => {
          commit('UPDATE_CATEGORIES_CONTRATS', contrats)
          return contrats
        })
    },
    fetchArborescenceTypeCulture ({ commit }) {
      return applicationApi.getAllTypeCultures()
        .then(arborescenceTypeCulture => {
          commit('UPDATE_ARBORESCENCE_TYPE_CULTURE', arborescenceTypeCulture)
        })
    },
    fetchGrainesRs3 ({ commit }) {
      return applicationApi.getAllGrainesRs3()
        .then(grainesRs3 => {
          commit('UPDATE_GRAINES_RS3', grainesRs3)
        })
    },
    getAvisCampagne ({ commit }) {
      return applicationApi.getAvisCampagne().then(avisCampagne => {
        commit('UPDATE_AVIS_CAMPAGNE', avisCampagne)
      })
    },
    updateAnneeRecolteActive ({ commit }, annee) {
      commit('UPDATE_ANNEE_RECOLTE_ACTIVE', annee)
    },
    updateCodeGraineActive ({ commit }, codeGraine) {
      commit('UPDATE_CODE_GRAINE_ACTIVE', codeGraine)
    }
  }
}

export default module
